import React from 'react';
import { IoLocationSharp, IoMail, IoLogoFacebook } from 'react-icons/io5';
import { MdPhone } from 'react-icons/md';
import { FaFacebookMessenger } from 'react-icons/fa';
import logo from '../assets/jkccLogo.png';
import { useBranches } from '../hooks/useBranches';

export const Footer = () => {
  const { branches, loading } = useBranches();
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 text-zinc-800 p-8 w-full flex justify-center items-center border-t border-gray-200">
      <div className="flex flex-col lg:w-[60vw] w-full gap-y-8">
        <div className="w-full">
          <div className="lg:w-[60vw] w-full justify-between flex flex-col lg:flex-row gap-8 lg:gap-x-16">
            {/* Logo and Description */}
            <div className="flex flex-col w-full lg:max-w-[320px] items-start gap-4">
              <div className="flex items-center gap-3">
                <img src={logo} alt="JKCC Logo" width={40} height={40} className="object-contain" />
                <h1 className="text-2xl font-bold bg-gradient-to-r from-zinc-800 to-zinc-600 bg-clip-text text-transparent">JKCC</h1>
              </div>
              <p className="text-sm max-w-[380px] leading-relaxed text-gray-600">
                Explore cutting-edge tech, expert repairs, and tailored IT solutions—because you deserve more
              </p>
              <div className="flex gap-3">
                <a 
                  href="https://www.facebook.com/JKCCofficial" 
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                  className="p-2 bg-white hover:bg-blue-500 hover:text-white rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  <IoLogoFacebook size={20} />
                </a>
                <a 
                  href="mailto:kissajasper@gmail.com" 
                  aria-label="Email"
                  className="p-2 bg-white hover:bg-yellow-500 hover:text-white rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  <IoMail size={20} />
                </a>
                <a 
                  href="https://m.me/JKCCofficial" 
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Messenger"
                  className="p-2 bg-white hover:bg-blue-600 hover:text-white rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  <FaFacebookMessenger size={20} />
                </a>
              </div>
            </div>

            {/* Useful Links */}
            <div className="flex flex-col gap-4 w-full items-start">
              <h2 className="font-bold text-lg border-b-2 border-yellow-400 pb-2">Useful Links</h2>
              <nav className="flex flex-col gap-3">
                <a href="/" className="text-gray-700 hover:text-yellow-500 hover:translate-x-1 transition-all duration-200 flex items-center gap-2">
                  <span className="text-yellow-500">→</span> Home
                </a>
                <a href="/about" className="text-gray-700 hover:text-yellow-500 hover:translate-x-1 transition-all duration-200 flex items-center gap-2">
                  <span className="text-yellow-500">→</span> About Us
                </a>
                <a href="/under-construction" className="text-gray-700 hover:text-yellow-500 hover:translate-x-1 transition-all duration-200 flex items-center gap-2">
                  <span className="text-yellow-500">→</span> Browse
                </a>
                <a href="/under-construction" className="text-gray-700 hover:text-yellow-500 hover:translate-x-1 transition-all duration-200 flex items-center gap-2">
                  <span className="text-yellow-500">→</span> Custom PC
                </a>
              </nav>
            </div>

            {/* Branches */}
            {!loading && branches.length > 0 && (
              <div className="flex flex-col w-full gap-4 items-start">
                <h2 className="font-bold text-lg border-b-2 border-yellow-400 pb-2">Contact Us</h2>
                
                {/* Email Contact */}
                <div className="flex flex-col gap-2 w-full pb-2 border-b border-gray-200">
                  <div className="flex items-center gap-2 text-xs text-gray-700">
                    <IoMail className="text-yellow-500" size={16} />
                    <a href="mailto:kissajasper@gmail.com" className="hover:text-yellow-500 transition-colors">
                      kissajasper@gmail.com
                    </a>
                  </div>
                  {/* <div className="flex items-center gap-2 text-xs text-gray-700">
                    <IoMail className="text-yellow-500" size={16} />
                    <a href="mailto:jasperlawrence@jasperkissa.com" className="hover:text-yellow-500 transition-colors">
                      jasperlawrence@jasperkissa.com
                    </a>
                  </div> */}
                </div>

                <div className="flex flex-col gap-4 w-full">
                  {branches.map((branch) => (
                    <div key={branch.id} className="flex flex-col gap-1">
                      <h3 className="font-semibold text-sm text-zinc-800">{branch.name}</h3>
                      <p className="text-xs text-gray-600 leading-relaxed">{branch.address}</p>
                      {branch.contactNumber && (
                        <div className="flex items-center gap-2 text-xs text-gray-700">
                          <MdPhone className="text-yellow-500" size={14} />
                          <a href={`tel:${branch.contactNumber.replace(/\s/g, '')}`} className="hover:text-yellow-500 transition-colors">
                            {branch.contactNumber}
                          </a>
                        </div>
                      )}
                      <a 
                        href={branch.mapUrl} 
                        target="_blank" 
                        rel="noreferrer"
                        className="text-xs text-blue-500 hover:text-yellow-500 transition-colors flex items-center gap-1"
                      >
                        <IoLocationSharp size={14} />
                        View on Maps
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="w-full pt-6">
          <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-4"></div>
          <div className="text-sm text-center text-gray-600">
            © 2025 Jasper Kissa Computer Center. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};
